export const GET_ALL_ACTIVE_ROLE = "GET_ALL_ACTIVE_ROLE"
export const GET_ALL_TEAM_ROLE = "GET_ALL_TEAM_ROLE"
export const GET_ALL_MANAGER_ROLE = "GET_ALL_MANAGER_ROLE"